export default "__VITE_ASSET__CRqpG1Lt__"